import vc from "../assets/vcBanner.png";
import vcPhone from "../assets/vcBannerM.png";
import { VcBiography } from "../components/shared/VcBiography";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";

const OfficeOfTheVc = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: officeOfVcData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["officeOfTheVC"],
    queryFn: async () => {
      const res = await axiosPublic.get("/discover-zums/office-of-the-vc");
      return res?.data?.data;
    },
  });
  console.log(officeOfVcData, "vc data");
  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  return (
    <div>
      {/* banner */}
      <div className="relative w-full z-10  h-screen  lg:h-[95vh]">
        <img
          src={officeOfVcData?.banner?.web_media_url || "/placeholder.svg"}
          alt="VC Banner"
          className="absolute inset-0 hidden object-cover w-full h-full md:block"
        />
        <img
          src={officeOfVcData?.banner?.mobile_media_url || "/placeholder.svg"}
          alt="VC Banner"
          className="absolute inset-0 block object-cover w-full h-full md:hidden"
        />
        <div className="absolute inset-0 z-10 w-full h-full bg-black/20"></div>
        <div className="container relative z-20 flex items-center justify-start w-full h-full p-8 mx-auto">
          {/* Text content */}
          <div className="text-white">
            <h1 className="max-w-2xl text-4xl font-bold font-domine md:text-5xl lg:text-7xl">
              {officeOfVcData?.banner?.title?.split(" ").slice(0, -1).join(" ")}{" "}
              <span className="bg-primary">
                {officeOfVcData?.banner?.title?.split(" ").slice(-1)}
              </span>
            </h1>

            <p className="mt-4 text-2xl font-semibold lg:mt-5">
              — {officeOfVcData?.banner?.sub_title}
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <VcBiography vcData={officeOfVcData} />
      </div>
    </div>
  );
};

export default OfficeOfTheVc;
